import styled from "styled-components";

import { motion } from "framer-motion";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 20000;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
`;

export const AnimatedImage = styled(motion.img)`
  width: 100%;
  height: auto;
  max-height: 200%; /* Permite margen para paneo */
  position: absolute;
  
`;

export const GashaContainer = styled.div`
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    background-image: url(${props => props.src});
    background-size: cover;
    background-position: bottom;
    z-index: 100;
`;
